import { SwRegistrationOptions } from '@angular/service-worker';

// Angular's build/serve define options supply this independently of runtime PRODUCTION.
declare const PWA_ENABLED: boolean;

export function pwaRegistrationOptions(): SwRegistrationOptions {
  return {
    enabled: typeof PWA_ENABLED === 'boolean' && PWA_ENABLED,
    registrationStrategy: 'registerWhenStable:30000',
  };
}
